<script setup lang="ts">
import { AppErrorMessages } from '../components';

const { visibility, message, list, color, icon, timer, clearSnackbar } = useSnackbar();

const hasList = computed(() => list.value.length > 0);
const hasIcon = computed(() => !!icon.value);
</script>
<template>
  <v-snackbar
    :model-value="visibility"
    :color="color"
    :timeout="timer"
    rounded
    class="global-snackbar"
    @update:model-value="clearSnackbar()"
  >
    <div class="global-snackbar__border d-flex align-center gap-sm">
      <div class="global-snackbar__content">
        {{ message }}
        <AppErrorMessages v-if="hasList" display="list" :error="list" class="global-snackbar__list" />
      </div>
      <div v-if="hasIcon" class="global-snackbar__icon">
        <v-icon :icon="icon" />
      </div>
    </div>
  </v-snackbar>
</template>
<style lang="scss" scoped>
@use '~/assets/scss/_spacing.scss' as *;
@use '~/assets/scss/_fonts.scss' as *;

.global-snackbar {
  &__content {
    flex-grow: 1;
  }

  &__content,
  &__list {
    font-weight: 500;
  }

  &__list {
    padding-top: 3px;
    color: inherit;
    opacity: 1;
  }

  :deep(.v-overlay__content) {
    min-height: auto;
    min-width: auto;
  }

  :deep(.v-snackbar__content) {
    padding: $spacing-sm !important;
    @include body-font(400, 12px, 16px);
  }

  @media (max-width: 960px) {
    padding-bottom: 70px !important;
    padding-left: 0 !important;
  }
}
</style>
